import {defineStore} from 'pinia'

export const useVariantStore = defineStore('variantStore', {
    state: () => ({
        colour: '',
        capacity: '',
        condition: ''
    })
})
